const TIMEZONE_MISMATCH_PROMPT_STORAGE_PREFIX = "timerquest.timezoneMismatchPrompt";

export function getCurrentTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  } catch (_error) {
    return "";
  }
}

export function getSupportedTimezones(extraTimezones = []) {
  try {
    if (typeof Intl.supportedValuesOf === "function") {
      return Intl.supportedValuesOf("timeZone");
    }
  } catch (_error) {
    // Fall through to the conservative fallback list below.
  }

  return Array.from(new Set(["UTC", ...extraTimezones.filter(Boolean)])).sort();
}

export function getTimezoneMismatchSignature(savedTimezone, detectedTimezone) {
  if (!savedTimezone || !detectedTimezone || savedTimezone === detectedTimezone) {
    return "";
  }

  return `${savedTimezone}::${detectedTimezone}`;
}

export function getTimezoneMismatchPromptStorageKey(userId) {
  return `${TIMEZONE_MISMATCH_PROMPT_STORAGE_PREFIX}:${userId}`;
}

export function readSeenTimezoneMismatch(userId) {
  try {
    if (!userId || typeof window === "undefined" || !window.localStorage) {
      return "";
    }

    return window.localStorage.getItem(getTimezoneMismatchPromptStorageKey(userId)) || "";
  } catch (_error) {
    return "";
  }
}

export function rememberSeenTimezoneMismatch(userId, signature) {
  try {
    if (!userId || !signature || typeof window === "undefined" || !window.localStorage) {
      return;
    }

    window.localStorage.setItem(getTimezoneMismatchPromptStorageKey(userId), signature);
  } catch (_error) {
    // Ignore storage failures so the app keeps working.
  }
}

export function clearSeenTimezoneMismatch(userId) {
  try {
    if (!userId || typeof window === "undefined" || !window.localStorage) {
      return;
    }

    window.localStorage.removeItem(getTimezoneMismatchPromptStorageKey(userId));
  } catch (_error) {
    // Ignore storage failures so the app keeps working.
  }
}
